import React from 'react';

import { Link } from 'react-router-dom';
import {Button} from 'player-components';

import'./style.css';


const products = ['iPhone', 'iPad'];

const NotSupportedSplash = ({platform, logoUrl}) => {

    return <div className="flex flex-1 flex-col space-y-3 justify-start px-6 py-5 items-center text-center mt-8 dark:text-secondary-300">
        <img className="chromeIcon mb-4" alt="Get Google chrome" src={logoUrl} />
        {products.includes(platform) && <div>
            <h3 classsname="mt-4 text-lg">You currently need <b>iOS 15</b> installed on your device to run this website.</h3>
            <a href="https://support.apple.com/en-gb/guide/iphone/iph3e504502/ios"><img className="chromeIcon" align="center" alt="Update iOS" src={`${process.env.PUBLIC_URL}/images/appstore.svg`} /></a>

        </div>}
        {!products.includes(platform) && <div>
        <img className="chromeIcon" alt="Get Google chrome" src={`${process.env.PUBLIC_URL}/images/chromeLogo.svg`} />
        <h1 className="mt-2 text-lg font-medium">Google Chrome</h1>
        <div className="storeLink">
            <a href="https://play.google.com/store/apps/details?id=com.android.chrome"><img alt="Google Play Store link" src={`${process.env.PUBLIC_URL}/images/google-play-badge.svg`} /></a>
        </div>
        <h2 className="mt-2 text-lg font-medium">You cannot use this application with the built-in browser on Samsung phones.</h2>

        <h2 className="mt-2 text-md font-medium">Please download Google Chrome and revisit the application.</h2>
        </div>}
    </div>
}

export default NotSupportedSplash;